import {JSX, memo} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {ButtonWithImage} from "@/shared/ui/buttons";
import {assetPath} from "@/shared/utils/asset-path";

interface SliderTestimonialsNavigationProps {
    currentIndex: number;
    totalTestimonials: number;
    hasNavigation: boolean;
    onPrev: () => void;
    onNext: () => void;
}

export const SliderTestimonialsNavigation = memo(function SliderTestimonialsNavigation({
    hasNavigation,
    onPrev,
    onNext,
}: SliderTestimonialsNavigationProps): JSX.Element {
    return (
        <div className="slider-testimonials__navigation">
            <ButtonWithImage
                className="slider-testimonials__navigation-button slider-testimonials__navigation-button--prev"
                variant="primary"
                onClick={onPrev}
                aria-label="Previous testimonial"
                disabled={!hasNavigation}
            >
                <SmartImage src={assetPath("/images/icons/navigation/arrow-left.svg")} alt="arrow" width={16} height={16} aria-hidden="true" />
            </ButtonWithImage>
            <ButtonWithImage
                className="slider-testimonials__navigation-button slider-testimonials__navigation-button--next"
                variant="primary"
                onClick={onNext}
                aria-label="Next testimonial"
                disabled={!hasNavigation}
            >
                <SmartImage src={assetPath("/images/icons/navigation/arrow-right.svg")} alt="arrow" width={16} height={16} aria-hidden="true" />
            </ButtonWithImage>
        </div>
    );
});
